var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"padding-top"},[_c('AppList',{attrs:{"opts":_vm.opts,"formOpts":_vm.formOpts,"items":_vm.items},on:{"formSuccess":_vm.onFormSuccess}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }